export default "__VITE_ASSET__C688HeRT__"